import api from "@/lib/api";

function b64urlToBuf(s) {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const b = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(b, (c) => c.charCodeAt(0)).buffer;
}

function bufToB64url(buf) {
  const bytes = new Uint8Array(buf);
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function prepareCreate(o) {
  return {
    ...o,
    challenge: b64urlToBuf(o.challenge),
    user: { ...o.user, id: b64urlToBuf(o.user.id) },
    excludeCredentials: (o.excludeCredentials || []).map((c) => ({ ...c, id: b64urlToBuf(c.id) })),
  };
}

function prepareGet(o) {
  return {
    ...o,
    challenge: b64urlToBuf(o.challenge),
    allowCredentials: (o.allowCredentials || []).map((c) => ({ ...c, id: b64urlToBuf(c.id) })),
  };
}

function credToJSON(cred) {
  const r = cred.response;
  const out = { id: cred.id, rawId: bufToB64url(cred.rawId), type: cred.type, response: {} };
  if (r.clientDataJSON) out.response.clientDataJSON = bufToB64url(r.clientDataJSON);
  if (r.attestationObject) out.response.attestationObject = bufToB64url(r.attestationObject);
  if (r.authenticatorData) out.response.authenticatorData = bufToB64url(r.authenticatorData);
  if (r.signature) out.response.signature = bufToB64url(r.signature);
  if (r.userHandle) out.response.userHandle = bufToB64url(r.userHandle);
  if (typeof cred.getClientExtensionResults === "function")
    out.clientExtensionResults = cred.getClientExtensionResults();
  return out;
}

export function passkeysSupported() {
  return typeof window !== "undefined" && !!window.PublicKeyCredential;
}

export async function registerPasskey() {
  if (!passkeysSupported()) throw new Error("Questo dispositivo non supporta l'accesso con impronta");
  const { data } = await api.post("/auth/passkey/register/options");
  const cred = await navigator.credentials.create({ publicKey: prepareCreate(data.publicKey) });
  if (!cred) throw new Error("Registrazione annullata");
  await api.post("/auth/passkey/register/verify", { ticket: data.ticket, credential: credToJSON(cred) });
  return true;
}

export async function loginWithPasskey() {
  if (!passkeysSupported()) throw new Error("Questo dispositivo non supporta l'accesso con impronta");
  const { data } = await api.post("/auth/passkey/login/options");
  const cred = await navigator.credentials.get({ publicKey: prepareGet(data.publicKey) });
  if (!cred) throw new Error("Accesso annullato");
  const res = await api.post("/auth/passkey/login/verify", { ticket: data.ticket, credential: credToJSON(cred) });
  return res.data;
}
